/* eslint sort-keys: "error" */

/**
 * ルーターの path に指定する値と、そのルーティングで表示される component で取得する path param を同期させるための定数
 */
export const PATH_PARAMETERS = {
  "/account/settlement/history/:orderId": "orderId",
} as const;
